<div mat-dialog-title>
  <div class="h4 mb-0">{{data.title}}</div>
  <button mat-icon-button (click)="onCancel()">
    <mat-icon svgIcon="close"></mat-icon>
  </button>
</div>

<div mat-dialog-content>
  <mat-form-field>
    <mat-label i18n="@@dprDetails.dprCopyActivityDialog.lblSelectDestinationDate">Select destination date</mat-label>
    <input
      matInput
      [matDatepickerFilter]="filterAvailableDates"
      [matDatepicker]="datePicker"
      [formControl]="selectedDate"
      [min]="minDate"
      [max]="maxDate"
      readonly
    />
    <mat-datepicker-toggle matIconSuffix [for]="datePicker"></mat-datepicker-toggle>
    <mat-datepicker #datePicker [startAt]="startDate"></mat-datepicker>
  </mat-form-field>

  <app-multiselect
    [selectLabel]="selectActivityStreamsLabel"
    [options]="activityStreams"
    [data]="selectedActivityStreams"
    [canEdit]="data?.canEdit"
    (selectionChanged)="onSelectionChanged($event)"
  ></app-multiselect>

  <app-multiselect
    [selectLabel]="selectCustomDataLabel"
    [options]="customData"
    [data]="selectedCustomData"
    [canEdit]="data?.canEdit"
    [isDisabled]="!customData.length"
    (selectionChanged)="onCustomDataSelectionChanged($event)"
  ></app-multiselect>
</div>

<div mat-dialog-actions class="d-flex">
  <button
    mat-flat-button
    color="primary"
    [disabled]="!this.selectedDate.value || !this.selectedActivityStreams.length"
    (click)="onCopy()"
    cdkFocusInitial
  >
    <mat-icon svgIcon="cloud-download"></mat-icon>
    <span>{{StaticMessage.CopyButton | staticMessage}}</span>
  </button>
  <button mat-button color="primary" (click)="onCancel()">{{StaticMessage.CancelButton | staticMessage}}</button>
</div>
